import { useState, MouseEvent, FC } from 'react';

import { Wallet } from 'lucide-react';
import { BaseMenu, BaseMenuItem } from 'wbs-components-lib';

import { UserSettingsTableActionsMenuProps } from './types';

export const UserSettingsTableActionsMenu: FC<UserSettingsTableActionsMenuProps> = ({
  user,
  handleVipTaskStatusUpdateModalOpen,
}) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpened = Boolean(menuAnchor);

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const { id } = user;

  const menuItems: BaseMenuItem[] = [
    {
      icon: <Wallet />,
      text: 'Configure Vip Task Status',
      onClick: () => handleVipTaskStatusUpdateModalOpen(user),
    },
  ];

  return (
    <BaseMenu
      key={id}
      menuItems={menuItems}
      menuAnchor={menuAnchor}
      isMenuOpened={isMenuOpened}
      handleOpenMenu={handleOpenMenu}
      handleCloseMenu={handleCloseMenu}
    />
  );
};
